export const RESET_PASSWORD = "RESET_PASSWORD"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR"
